import React, {FC} from 'react';

import {cn} from '@bem-react/classname';
import {Button, Text} from '@gravity-ui/uikit';
import i18n from 'ui/i18n';
import addQueryParams from 'ui/utils/addQueryParams';
import * as Metrika from 'ui/utils/metrika';

import './Promo.scss';

const {
    YC: {
        routes: {adminUrl},
    },
} = window;

const promoAdminUrl = addQueryParams(adminUrl, {
    utm_campaign: 'teaser',
    utm_source: 'success',
    utm_content: 'slider',
});

export const cnPromo = cn('Promo');

const onClick = () => {
    Metrika.promo();
};

const Promo: FC = () => {
    return (
        <section className={cnPromo()}>
            <div className={cnPromo('Messages')}>
                <Text variant="subheader-3" as="div">
                    {i18n('success-page', 'promo-title')}
                </Text>
                <Text variant="body-1" color="secondary" as="div">
                    {i18n('success-page', 'promo-description')}
                </Text>
            </div>

            <Button
                size="l"
                view="action"
                href={promoAdminUrl}
                rel="noreferrer"
                target="_blank"
                onClick={onClick}
            >
                {i18n('success-page', 'create-form')}
            </Button>
        </section>
    );
};

export default Promo;
